import classNames from 'classnames';
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ApsContentContainer, ApsContentMask } from 'UserExperience/portal-vnext';
import { useSession } from '../../common/session/SessionContext';
import UploadCategoryList from './UploadCategoryList';
import UploadOption from './UploadOption';


const Start = () => {

  const { t } = useTranslation();
  const history = useHistory();
  const { resetSession } = useSession();
  const [selectUploadOption, setSelectUploadOption] = useState(null);
  const contentMaskClasses = classNames('breakpoint--tablet--is-hidden', {
    'content-mask-open': selectUploadOption
  });

  const clearSelectUploadOption = () => {
    setSelectUploadOption(null);
  }

  const uploadOptionSelected = () => {
    history.push('/upload', selectUploadOption);
  };

  useEffect(() => {
    resetSession();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  /**
   * What is this? When the application is running on a mobile device, there are animated transitions that occur
   * between the pages. In the original AngularJs application, the transition between the Start and Upload pages
   * shows the Start page slide away to the left. And the Start page (as it leaves) correctly still looks as it did
   * after the user selected a category, with the UploadOption component displaying the 'Begin' button. In the React
   * version, the selected category is null because the component's state has been cleared (the component is being
   * unmounted). The only way I could find to reliably get this page to look correct as it transitions to the Upload
   * page is to grab the selected category from the router's state as it switches to the /upload route, and then
   * render the UploadOption component to look as it did before the user clicked the 'Begin' button. I'm sure there
   * is an easier/better way to do this, but I tried a couple (ok, a lot) of other approaches that did not work.
   */
  if (history.location.pathname.indexOf("/upload") !== -1) {
    const uploadOption = history.location?.state;
    return (
      <UploadOption
        uploadOption={uploadOption}
        name={(uploadOption?.displayNameTextId) ? t(uploadOption.displayNameTextId) : ''}
        description={(uploadOption?.shortDescriptionTextId) ? t(uploadOption.shortDescriptionTextId) : ''}
        optionClosed={() => {}}
        startUpload={() => {}}
        selectText={t('startScreen.selectOption')}
        beginText={t('startScreen.beginButton')}
      />      
    );
  }

  /**
   * This is the normal render that occurs when you are on the Start page and not leaving for the Upload page.
   */
  return (
    <>
      <div
        className="aps-intro-text breakpoint--tablet--is-visible--block"
      >
        {t('startScreen.chooseCategory')}
      </div>

      <ApsContentContainer
        id="start-page-content-container"
        containerPadding={true}
      >
        <UploadCategoryList
          chooseCategoryTitle={t('global.title')}
          chooseCategoryText={t('startScreen.chooseCategory')}
          categorySelected={setSelectUploadOption}
        />
        <UploadOption
          uploadOption={selectUploadOption}
          name={(selectUploadOption?.displayNameTextId) ? t(selectUploadOption.displayNameTextId) : ''}
          description={(selectUploadOption?.shortDescriptionTextId) ? t(selectUploadOption.shortDescriptionTextId) : ''}
          optionClosed={clearSelectUploadOption}
          startUpload={() => uploadOptionSelected()}
          selectText={t('startScreen.selectOption')}
          beginText={t('startScreen.beginButton')}
        />
      </ApsContentContainer>

      <ApsContentMask
        className={contentMaskClasses}
        onClick={clearSelectUploadOption}
      />
    </>
  );
};

export default Start;